import { Component, HostListener, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { CustomDashboardsService } from '../../../my-limegear/services/my-limegear.service';
import { DisplayOptionsDialogComponent } from 'app/modules/shared/components/display-options-dialog/display-options-dialog.component';
import { MatDialog } from '@angular/material/dialog';

export interface ICardControllerInfo {
    cardId: string;
    cardParentPageKey?: number;
    cardTitle: string;
    showCardControllers: boolean;
    showDropdown?: boolean;
}

@Component({
    selector: 'card-controller-panel',
    templateUrl: './card-controller-panel.component.html',
    styleUrls: ['./card-controller-panel.component.scss'],
})
export class CardControllerPanelComponent implements OnInit, OnChanges {
    constructor(
        private _customDashboardService: CustomDashboardsService,
        private _router: Router,
        private _dialog: MatDialog
    ) {}

    dashboard = '';
    @Input() cardInfo: ICardControllerInfo;

    corporateDasboardRemoveText = 'Remove from Corporate Dashboard';
    corporateDasboardAddText = 'Add to Corporate Dashboard';
    corporateDasboardText: string;
    corporateDashboardId = 'corporate';
    cardControlContentId = '';
    isCustomDashboard = false;

    ngOnInit() {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes.cardInfo) {
            let change = <ICardControllerInfo>changes.cardInfo.currentValue;
            let url = this._router.url.split('?')[0];
            this.dashboard = url.includes('corporate-dashboard') ? this.corporateDashboardId : '';
            this.cardControlContentId = 'card-control-dropdown-content-' + change.cardId;
            this.corporateDasboardText =
                this.dashboard === this.corporateDashboardId
                    ? this.corporateDasboardRemoveText
                    : this.corporateDasboardAddText;
            // Find a good dynamic logic
            this.isCustomDashboard = this.dashboard === this.corporateDashboardId;
            this.cardInfo.showDropdown = change.showDropdown ?? true;
        }
    }

    cardControlDotsIconClick(id: string) {
        let element = document.getElementById(id);
        if (element) {
            if (element.style.display === 'none' || element.style.display === '') {
                element.style.display = 'block';
            } else {
                element.style.display = 'none';
            }
        }
    }

    cardControlFilterIconClick(id: string) {
        let element = document.getElementById(id);
        if (element) {
            if (element.style.display === 'none' || element.style.display === '') {
                element.style.display = 'block';
            } else {
                element.style.display = 'none';
            }
        }
        let dialogRef = this._dialog.open(DisplayOptionsDialogComponent, {
            data: {
                cardName: this.cardInfo.cardTitle,
                optionalSummaryList: [],
            },
        });
    }
    cardControlItemSelect() {
        if (this.corporateDasboardText === this.corporateDasboardRemoveText) {
            this._customDashboardService.removeWidget(
                this.corporateDashboardId,
                this.cardInfo.cardId
            );
            this.corporateDasboardText = this.corporateDasboardAddText;
        } else {
            this._customDashboardService.addWidget(this.corporateDashboardId, this.cardInfo.cardId);
            this.corporateDasboardText = this.corporateDasboardRemoveText;
        }
        this.cardControlClose(this.cardControlContentId);
    }

    cardControlClose(id) {
        let element = document.getElementById(id);
        if (element) {
            element.style.display = 'none';
        }
    }

    cardControlOpen(id) {
        let element = document.getElementById(id);
        if (element) {
            element.style.display = 'block';
        }
    }

    @HostListener('window:keydown', ['$event'])
    keyEvent(event: KeyboardEvent) {
        //if (event.code == 'ArrowRight') {
        //    //Add code here;
        //}
        //if (event.code == 'ArrowLeft') {
        //    //Add code here;
        //}
    }

    @HostListener('mouseleave', ['$event']) onLeave(e: MouseEvent) {
        this.cardControlClose(this.cardControlContentId);
    }
}
